/* eslint camelcase: 0 */
import { toUserProps } from './user'
import { toFileProps } from './file'
import { Message, MessageRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IMessageProps, EmptyMessagePropsFactory } from '@/entities/Message'
import MessageDetail from '@/infrastructure/network/Monitaro/schema/models/MessageDetail'

export const toMessageProps = (props: Message | MessageDetail | null | undefined): IMessageProps => {
  if (!props) {
    return EmptyMessagePropsFactory()
  }

  const { id, hospital_id, hospital, type, from, title, content, users, industries, properties, files, sent_at, created_at, updated_at } = props
  let recipients
  if ('recipients' in props && Array.isArray(props.recipients)) {
    recipients = props.recipients
  }
  return EmptyMessagePropsFactory({
    id,
    hospitalId: hospital_id,
    hospital,
    type,
    from,
    title,
    content,
    users: users?.map(toUserProps),
    recipients,
    industries,
    properties,
    files: files?.map(toFileProps),
    sentAt: sent_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toMessageRequest = (props: IMessageProps): MessageRequest => {
  const { type, from, title, content, temporary, keeps, users, industries, data } = props
  return {
    type: type!,
    from: from!,
    title: title!,
    content: content!,
    industries: industries || [],
    temporary: temporary!,
    users: users?.map((prop) => prop.id!) || [],
    keeps: JSON.stringify(keeps),
    data: data!
  }
}
